import { useUpgradeRecommendation } from '../hooks/useUpgradeRecommendation';
export const UpgradeRecommendationPrefetch = () => {
  useUpgradeRecommendation();
  return null;
};
//# sourceMappingURL=UpgradeRecommendationPrefetch.js.map